import type { ColorLabStrings } from "./colorlab.vi.ts";

/** English twin of `colorlab.vi.ts`. */
export const colorLabEn: ColorLabStrings = {
  pours: (n) => `Poured ${n}`,
  stuck: "Stuck! Undo a few steps or restart.",
  hintCost: "Using a hint caps this level at 2 stars. Still want it?",
  recipes: "Flask recipes",
  recipeWith: "with",
  recipeMakes: "makes",
  resultPours: (n, best) =>
    n <= best ? `You poured ${n} times, as neat as the best solution!` : `You poured ${n} times, the neatest solution takes ${best}.`,
  resultRule: (three, two) => `Three stars for ${three} pours or fewer, two stars for ${two} or fewer.`,
  resultHint: "You used a hint, so 2 stars at most.",
};
